import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { emptyStateGraphics, Text } from '@frontend/design-system';
import { useGlobalSearch } from '../provider';

type GlobalSearchContentProps = {
  children: React.ReactNode;
};

export const GlobalSearchContent = ({ children }: GlobalSearchContentProps) => {
  const { searchFor, hasResults } = useGlobalSearch(['searchFor', 'hasResults']);

  const showEmptyState = !hasResults && searchFor === 'all';
  return (
    <>
      <section
        css={css`
          overflow-y: auto;
          flex: 1;
        `}
      >
        {children}
      </section>
      {showEmptyState && <EmptyStateGraphic />}
    </>
  );
};

const EmptyState = emptyStateGraphics.search;

const EmptyStateGraphic = () => {
  const { t } = useTranslation();
  const { debouncedSearchTerm } = useGlobalSearch(['debouncedSearchTerm']);

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing(2)};
        align-items: center;
        padding: ${theme.spacing(3, 5)};
      `}
    >
      <EmptyState
        css={css`
          max-width: 300px;
          max-height: 300px;
        `}
      />
      <Text css={{ width: '100%' }} textAlign='center' color='light' size='large'>
        {t(`Sorry, we couldn't find any results for `)}
        <span
          css={css`
            font-weight: ${theme.font.weight.bold};
          `}
        >
          "{debouncedSearchTerm}"
        </span>
      </Text>
    </div>
  );
};
